import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

type ConfirmationDialogProps = {
  open: boolean;
  title: string;
  description: string;
  confirmLabel: string;
  cancelLabel?: string;
  confirmColor?: "primary" | "error";
  isConfirming?: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
};

export function ConfirmationDialog({
  open,
  title,
  description,
  confirmLabel,
  cancelLabel = "Cancel",
  confirmColor = "primary",
  isConfirming = false,
  onClose,
  onConfirm,
}: ConfirmationDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={isConfirming ? undefined : onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ pt: 0, textAlign: "center" }}>
        <Box
          sx={(theme) => ({
            width: 72,
            height: 72,
            borderRadius: "50%",
            backgroundColor:
              confirmColor === "error"
                ? theme.palette.error.main
                : theme.palette.primary.main,
            color: theme.palette.common.white,
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            mt: 2,
          })}
        >
          <WarningAmberRoundedIcon sx={{ fontSize: 36 }} />
        </Box>
        <Typography variant="h5" component="div" sx={{ mt: 2 }}>
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ textAlign: "center", pt: 1 }}>
        <Typography color="text.secondary">{description}</Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3, justifyContent: "center", gap: 1.5 }}>
        <Button onClick={onClose} disabled={isConfirming} variant="outlined">
          {cancelLabel}
        </Button>
        <Button
          onClick={() => void onConfirm()}
          disabled={isConfirming}
          color={confirmColor}
          variant="contained"
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
